<template>
  <div class="col-lg-10 col-md-11 col-sm-12 m-auto">
    <div class="jipvio-contract contract">
      <img src="/../img/contract3.jpg" />

      <!-- p3-line1 매매교환 9억원 이상 -->
      <div class="con-line" id="con3-line1">
        <div class="con-line-div" id="con3-line1-div1">
          <input class="con-line-input" v-model="houseOver900mil" disabled />
        </div>
      </div>

      <!-- p3-line2 임대차 등(매매,교환 이외) 6억원 이상 -->
      <div class="con-line" id="con3-line2">
        <div class="con-line-div" id="con3-line2-div1">
          <input class="con-line-input" v-model="houseOver600mil" disabled />
        </div>
      </div>

      <!-- p3-line3 오피스텔 위 적용대상 외의 경우 -->
      <div class="con-line" id="con3-line3">
        <div class="con-line-div" id="con3-line3-div1">
          <input class="con-line-input" v-model="offiMaxRate" disabled />
        </div>
      </div>

      <!-- p3-line4 주택 오피스텔 외(토지 상가 등) -->
      <div class="con-line" id="con3-line4">
        <div class="con-line-div" id="con3-line4-div1">
          <input class="con-line-input" v-model="otherMaxRate" disabled />
        </div>
      </div>

      <!--p3-line5 이전 버튼 -->
      <div class="con-line" id="con3-line5">
        <div class="con-line-div" id="con3-line5-div1">
          <el-button
            class="btn con2-line13-btn"
            id="con3-line5-prevButton"
            @click="$emit('ToPage2')"
          >
            이전페이지
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from "element-ui";
export default {
  //   props: ["houseOver900mil", "houseOver600mil", "offiMaxRate", "otherMaxRate"],
  components: {
    [Button.name]: Button
  },

  data() {
    return {
      //contract 3
      houseOver900mil: 9,
      houseOver600mil: 8,
      offiMaxRate: 9,
      otherMaxRate: 9

      //=========================
    };
  }
};
</script>

<style></style>
